import { Entypo } from "@expo/vector-icons";
import { useState } from "react";
import { TouchableOpacity, View } from "react-native-ui-lib";
import { DropZone } from "../../../../../../components/DragDrop";
import { ChangePageBarVariant } from "../../../../../../utilities/layout/constants";
import { ValueOf } from "../../../../../../utilities/type-helpers";

export type ChangePageBarProps = {
  variant: ValueOf<typeof ChangePageBarVariant>;
  onEnter: () => void;
  onLeave?: () => void;
  visible: boolean;
};

export function ChangePageBar({
  variant,
  onEnter,
  onLeave,
  visible,
}: ChangePageBarProps) {
  const [active, setActive] = useState(false);

  const handleOnEnter = () => {
    setActive(true);
    onEnter();
  };

  const handleOnLeave = () => {
    if (onLeave) {
      onLeave();
    }
    setActive(false);
  };

  if (!visible) {
    return null;
  }

  const variantProps = getVariantProps(variant);

  const entypoName = getEntypoName(variant);

  return (
    <TouchableOpacity
      style={[
        {
          backgroundColor: "#cccccc33",
          position: "absolute",
          top: 0,
          bottom: 0,
          width: "6%",
          justifyContent: "center",
        },
        variantProps && variantProps.styles,
        active && activeStyles,
      ]}
      onPress={onEnter}
    >
      <DropZone
        id={variantProps?.id || ""}
        style={{ flex: 1 }}
        onEnter={handleOnEnter}
        onLeave={handleOnLeave}
      >
        <View
          style={{ flex: 1, justifyContent: "center", alignItems: "center" }}
        >
          {entypoName && <Entypo name={entypoName} size={24} color="black" />}
        </View>
      </DropZone>
    </TouchableOpacity>
  );
}

function getEntypoName(variant: ValueOf<typeof ChangePageBarVariant>) {
  switch (variant) {
    case ChangePageBarVariant.Left:
      return "chevron-left";
    case ChangePageBarVariant.Right:
      return "chevron-right";
    case ChangePageBarVariant.Add:
      return "plus";
    case ChangePageBarVariant.Remove:
      return "minus";
  }
}

function getVariantProps(variant: ValueOf<typeof ChangePageBarVariant>) {
  const baseStyles = {
    top: 0,
    bottom: 0,
  };

  const leftStyles = {
    ...baseStyles,
    left: 0,
  };

  const rightStyles = {
    ...baseStyles,
    right: 0,
  };

  switch (variant) {
    case ChangePageBarVariant.Left:
      return { id: ChangePageBarVariant.Left, styles: leftStyles };
    case ChangePageBarVariant.Right:
      return { id: ChangePageBarVariant.Right, styles: rightStyles };
    case ChangePageBarVariant.Add:
      return { id: ChangePageBarVariant.Add, styles: rightStyles };
    case ChangePageBarVariant.Remove:
      return { id: ChangePageBarVariant.Left, styles: leftStyles };
  }
}

const activeStyles = {
  backgroundColor: "#cccccc77",
};
